// ============================================================================
// delete-account-confirm — helpers purs (testables) pour la modale de
// suppression de compte.
// ============================================================================
// Miroir du contrat serveur (`supabase/functions/delete-account/index.ts`) qui
// vérifie que le body contient `confirm === 'SUPPRIMER'`. On applique la même
// normalisation côté client pour désactiver le bouton tant que le texte tapé
// n'est pas exact.

/** Le mot exact que l'utilisateur doit taper pour confirmer la suppression. */
export const DELETE_ACCOUNT_CONFIRM_WORD = 'SUPPRIMER';

/**
 * Normalise ce que l'utilisateur a tapé : trim + uppercase, pour tolérer les
 * espaces accidentels et la casse. Toute autre différence (fautes de frappe,
 * accents) exige une correction — c'est volontaire (confirmation active).
 */
export function normalizeDeleteConfirmInput(v: string): string {
  return v.trim().toUpperCase();
}

/** Vrai si l'utilisateur a tapé le mot de confirmation attendu. */
export function isDeletionConfirmed(v: string): boolean {
  return normalizeDeleteConfirmInput(v) === DELETE_ACCOUNT_CONFIRM_WORD;
}
